export const AmazonRssFeed = 'amazonRssFeed';
